import React from "react";
import FatLoss from "../../../../../images/change-goal-pictures/weight-loss-2020.png";
import Maintenance from "../../../../../images/change-goal-pictures/maintenance-2020.png";
import MuscleGain from "../../../../../images/change-goal-pictures/muscle-gain-2020.png";
import ReverseDieting from "../../../../../images/change-goal-pictures/reverse-2020.png";
import PauseMode from "../../../../../images/new-vacation-mode/pause-mode.svg";
import PracticeMode from "../../../../../images/new-vacation-mode/practice-mode.svg";
import styled from "styled-components";

const VacationText = styled.span`
  background: #06010d;
  border-radius: 30px;
  display: block;
  padding: 0px 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  color: ${props => props.color || "#32F6DB"};
`;

const ProfileCard = (props) => {
  const GoalIcon = {
    'FAT LOSS': <img src={FatLoss} alt="fat-loss" />,
    'MUSCLE GAIN': <img src={MuscleGain} alt="muscle-gain-thumbnail" />,
    'REVERSE DIETING': <img src={ReverseDieting} alt="reverse" />,
    'MAINTENANCE': <img src={Maintenance} alt="maintenance" />,
  }

  const account = props.account
  const isPaused = account.user.vacation_mode && !account.user.vacation_mode_info?.practice_mode
  const isPractice = account.user.vacation_mode && account.user.vacation_mode_info?.practice_mode
  const icon = isPaused ? <img src={PauseMode} alt="pause-mode" /> : isPractice ? <img src={PracticeMode} alt="practice-mode" /> : GoalIcon[props.goal]

  const now = new Date()
  const birthDate = new Date(account.user.birthdate)
  const age = Math.floor((now - birthDate)/(1000*31556926))
  const heightTotalInches = Math.round(Number(account.user.height) * 39.3701)
  const heightFeet = Math.floor(heightTotalInches / 12);;
  const heightInch = heightTotalInches % 12;

  const formatLifestyleLevel = (lifestyleLevel) => {
    const labels = {
      0: 'Sedentary',
      1: 'Lightly Active',
      2: 'Moderately Active',
      3: 'Very Active',
      4: 'Intense'
    }

    return labels[lifestyleLevel]
  }

  const formatExerciseLevel = (exerciseLevel) => {
    const labels = {
      0: 'Sedentary',
      1: 'Lightly Active',
      2: 'Moderately Active',
      3: 'Very Active',
      4: 'Extreme Athlete'
    }

    return labels[exerciseLevel]
  }

  return (
    <div className="avn-widget">
      <div className="profile-card">
        <div className="data">
          <div className="profile-left">
            <div
              className="profile-pic"
              style={{ backgroundImage: `url(${props.profilePic})` }}
              alt="pic"
            />
            <div>
              <h2>{props.name}</h2>
              <h3>{props.email}</h3>
              <div className='account-content'>
                <div className='account-content-inner'>
                  <p><span>Weight:</span>{props.currentWeight}</p>
                  <p><span>Age:</span>{age}</p>
                  <p><span>Gender:</span>{account.user.gender === 'MALE' ? 'Male' : 'Female'}</p>
                  <p><span>Height:</span>{heightFeet + ' feet ' + heightInch + ' inches'}</p>
                </div>
                <div className='account-content-inner'>
                  <p><span>Lifestyle Level:</span>{formatLifestyleLevel(account.user.lifestyle_level)}</p>
                  <p><span>Exercise Level:</span>{formatExerciseLevel(account.user.exercise_level)}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="profile-right">
            <div>
              <div className="vertical-container">
                <div className="profile-card-goal">
                  {icon}
                  {!!isPaused && <VacationText color="#32F6DB">Goal paused</VacationText>}
                  {!!isPractice && <VacationText color="#CFE92A">Practice mode</VacationText>}
                  <span className="goal-text">{props.goalText}</span>
                  <span>{props.goalLevel}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
